<template>
  <div>
    <div v-show="showPage==='首页'">
      <STable
        ref="tableref"
        :url="url"
        :columns="columns"
        :handles="handles"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </div>
    <div v-if="showPage==='详情'">
      <singleDetail :id="dataId" :form-data="formData" @backHome="backHome()" />
    </div>
    <el-dialog
      v-if="stopDialog"
      v-dialogDrag
      title="终止"
      :visible.sync="stopDialog"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      width="50%"
      center
    >
      <div style="width: 90%;margin:0 auto">
        <el-form ref="stopFormRef" :model="stopForm" :rules="stopRules" label-width="100px">
          <el-form-item label="终止原因" prop="stopReason">
            <el-input v-model="stopForm.stopReason" type="textarea" :rows="4" placeholder="请输入活动终止原因" />
          </el-form-item>
        </el-form>
      </div>
      <div class="flexJCenter mt-25">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="onSubmit()">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import singleDetail from './singleDetail.vue'
export default {
  components: { singleDetail },
  data() {
    return {
      showPage: '首页',
      dataId: 0,
      stopDialog: false,
      stopId: '', // 活动终止的Id
      url: '/activity/page?type=3',
      columns: [
        {
          label: '活动名称',
          prop: 'name'
        },
        {
          label: '消费维度',
          prop: 'consumptionType',
          template: function(index, record) {
            return record.consumptionType === '1' ? '电量' : '金额'
          }
        },
        {
          label: '活动状态',
          prop: 'status',
          template: function(index, record) {
            if (record.status === '1') {
              return '未开始'
            } else if (record.status === '2') {
              return '进行中'
            } else if (record.status === '3') {
              return '结束'
            } else if (record.status === '4') {
              return '终止（手动）'
            } else if (record.status === '5') {
              return '终止（自动）'
            }
          }
        },
        {
          label: '活动说明',
          prop: 'description'
        },
        {
          label: '活动开始时间',
          prop: 'start',
          width: '100px'
        },
        {
          label: '活动结束时间',
          prop: 'end',
          width: '100px'
        },
        {
          label: '参与用户数',
          prop: 'userCount',
          template: function(index, record) {
            if (record.userCount) {
              return record.userCount
            } else {
              return 0
            }
          }
        },
        {
          label: '关闭原因',
          prop: 'stopReason'
        },
        {
          label: '修改人',
          prop: 'updateBy'
        },
        {
          label: '修改时间',
          prop: 'updateTime',
          width: '150px'
        }
      ],
      handles: {
        width: 220,
        btns: [
          {
            label: '详情',
            permission: 'activity.single.consumption.activity.details',
            handle: record => {
              const ruleForm = {
                activityName: record.name,
                activityTime: [record.start, record.end],
                activityExplain: record.description
              }
              const configForm = {
                consumptionDimension: record.consumptionType,
                rewardStandard: record.coupons[0].amount,
                coupon: record.coupons[0].coupons,
                partakeNum: record.times,
                powerStation: record.stationType,
                stationValue: record.stationValue.split(',')
              }
              const partakeForm = {
                partakeUser: record.userType,
                userValue: record.userValue.split(',')
              }
              this.formData = {
                ruleForm: ruleForm,
                configForm: configForm,
                partakeForm: partakeForm
              }
              this.dataId = record.id
                    this.$router.push({
                 path:'./singleDetail',
                 query:{
                  id:this.dataId,
                  infoForm:encodeURIComponent(JSON.stringify(this.formData))
                 }
              })
              // this.showPage = '详情'
            }
          },
          {
            label: '修改',
            permission: 'activity.single.consumption.activity.update',
            getLabelDisabled: record => {
              return record.status !== '1'
            },
            handle: record => {
              const ruleForm = {
                activityName: record.name, // 活动名称
                activityTime: [record.start, record.end], // 活动时间
                activityExplain: record.description// 活动说明
              }
              const configForm = {
                consumptionDimension: record.consumptionType, // 消费维度
                rewardStandard: record.coupons[0].amount, // 奖励标准
                coupon: record.coupons[0].coupons, // 优惠券数组 类型-couponId 数量-count
                partakeNum: record.times, // 可参与次数
                powerStation: record.stationType, // 活动电站
                stationValue: record.stationValue.split(',')// 活动电站下面的树的数据
              }
              const partakeForm = {
                partakeUser: record.userType, // 可参与用户
                userValue: record.userValue.split(',')// 可参与用户下面的树的数据
              }
              const data = {
                ruleForm: ruleForm,
                configForm: configForm,
                partakeForm: partakeForm,
                id: record.id
              }
              this.$router.push({
                path: 'singleModify',
                query: data
              })
            }
          },
          {
            label: '终止',
            permission: 'activity.single.consumption.activity.terminate',
                     style:'color:red',
            getLabelDisabled: record => {
              return record.status > 2
            },
            handle: resp => {
              this.stopId = resp.id
              this.stopDialog = true
            }
          }
        ]
      },
      query: [
        {
          label: '活动名称',
          prop: 'name',
          placeholder: '请输入活动名称'
        },
        {
          label: '活动状态',
          prop: 'status',
          placeholder: '请选择活动状态',
          type: 'select',
          data: [{
            label: '未开始',
            value: '1'
          }, {
            label: '进行中',
            value: '2'
          }, {
            label: '结束',
            value: '3'
          }, {
            label: '终止（手动）',
            value: '4'
          }, {
            label: '终止（自动）',
            value: '5'
          }]
        },
        {
          label: '活动开始日期',
          prop: 'start',
          placeholder: '',
          type: 'date3'
        },
        {
          label: '活动结束日期',
          prop: 'end',
          placeholder: '',
          type: 'date3'
        },
        {
          label: '消费维度',
          prop: 'consumptionType',
          placeholder: '请选择消费维度',
          type: 'select',
          data: [{
            label: '金额',
            value: '2'
          }, {
            label: '电量',
            value: '1'
          }]
        }
      ],
      toolbar: [
        {
          label: '新增',
          permission: 'activity.single.consumption.activity.add',
          type: 'primary',
          before: (index, record) => {
            this.$router.push({
              path: 'singleAdd'
            })
          }
          // before: (index, record) => {
          //   this.stopDialog = true
          // }
        }
      ],
      formData: {},
      stopForm: {
        stopReason: ''// 终止原因
      },
      stopRules: {
        stopReason: [
          { required: true, message: '请输入活动终止原因', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    /**
     * 关闭终止的弹窗
     */
    closeDialog() {
      this.stopId = ''
      this.stopForm.stopReason = ''
      this.stopDialog = false
      this.$refs.tableref.queryTable()
    },
    /**
     * 终止原因提交
     */
    onSubmit() {
      let stopFormBool = false
      this.$refs['stopFormRef'].validate(valid => {
        stopFormBool = valid
      })
      if (stopFormBool) {
        const data = {
          id: this.stopId,
          stopReason: this.stopForm.stopReason
        }
        this.$store.dispatch('form/handle', {
          url: '/activity/stop',
          data: data,
          method: 'post',
          callback: resp => {
            this.$notify({
              title: '成功',
              message: '活动终止成功',
              type: 'success',
              duration: 1500
            })
            this.closeDialog()
          }
        })
      }
    },
    /**
     * 返回首页
     */
    backHome() {
      this.showPage = '首页'
    }
  }
}
</script>

<style scoped lang="less">
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
       /deep/ .is-disabled{
     color: #C0C4CC !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/activityManagement/singleConsumption.vue